export default "__VITE_ASSET__CLk7Dm6i__"